const PREVIEW_LIMIT = 35;

export function ManagerRemarksCell({ remarks, maxLength = PREVIEW_LIMIT }) {
  const trimmed = remarks?.trim();

  if (!trimmed) {
    return <span className="text-[var(--color-text-secondary)]">-</span>;
  }

  const preview =
    trimmed.length > maxLength ? `${trimmed.slice(0, maxLength).trimEnd()}...` : trimmed;

  return (
    <span
      className="block text-sm text-[var(--color-text-secondary)] whitespace-nowrap overflow-hidden text-ellipsis max-w-[220px]"
      title={trimmed}
    >
      {preview}
    </span>
  );
}
